module.exports = __webpack_public_path__ + "img/modal-bg.9ce1cfd4.png";